/* eslint-disable no-plusplus */
import { Component } from 'react';

class PasswordMaskInput extends Component {
  state = {
    maskedValue: null,
    length: 0
  };
  handleChange = (event) => {
    clearTimeout(this.timerID);
    const {value} = event.target;

    if (value.length === this.state.length + 1) {
      this.setState({
        length: value.length,
        maskedValue: PasswordMaskInput.maskValue(value)
      });
    } else {
      this.setState({length: value.length});
    }

    this.scheduleMaskHiding();

    if (this.props.onChange && this.props.onChange !== undefined) {
      this.props.onChange(value);
    }
  };

  static maskValue(value) {
    let masked = '';
    for (let i = 0; i < value.length - 1; i++) {
      masked += '•';
    }
    masked += value.charAt(value.length - 1);
    return masked;
  }

  scheduleMaskHiding() {
    this.timerID = setTimeout(() => {
      this.setState({
        maskedValue: null
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.timerID);
  }

  render() {
    return (
      <div style={{position: 'relative'}}>
        <input
          className="form-control"
          type='password'
          {...this.props}
          onChange={this.handleChange}
        />
        {this.state.maskedValue && (
          <span style={{
            display: 'block',
            zIndex: 1000,
            lineHeight: '1.7',
            width: '100%',
            overflow: 'hidden',
            position: 'absolute',
            top: 0,
            left: 0,
            height: '38px',
            backgroundColor: '#f6f6f6',
            border: '1px solid #d7d7d7',
            outline: 0,
            outlineOffset: '-2px',
            borderRadius: '3px',
            color: '#575757',
            margin: 0,
            padding: '7px 14px 5px 14px'
          }}
          >
            {this.state.maskedValue}
          </span>
        )}
      </div>

    );
  }
}

export default PasswordMaskInput;
